import './RateComponent/export'
import './AudioCoverComponent/export'
import './JumpHistoryComponent/export'
import './QualityComponent/export'
import './FastForwardComponent/export'

export { default as RateComponent } from './RateComponent'
export { default as AudioCoverComponent } from './AudioCoverComponent'
export { default as JumpHistoryComponent } from './JumpHistoryComponent'
export { default as QualityComponent } from './QualityComponent'
export { default as FastForwardComponent } from './FastForwardComponent'



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/aliplayer/components/index.js